// custom-form.js
(function () {
  // Utility: find the nearest purchase-option label from an element
  function findOptionLabel(el) {
    return el && (el.closest ? el.closest('.purchase-option') : null);
  }

  // Toggle selected class on a given label and remove from siblings
  function selectOptionLabel(label) {
    if (!label) return;
    document.querySelectorAll('.purchase-option').forEach(function (l) {
      l.classList.remove('selected');
    });
    label.classList.add('selected');
  }

  // Handle change events (this uses event delegation so it works even if the block is injected later)
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target) return;
    // Radio inside purchase-option changed
    if (target.matches && target.matches('#custom-product-form input[type="radio"], .purchase-option input[type="radio"]')) {
      var label = findOptionLabel(target);
      selectOptionLabel(label);
    }
  }, true);

  // Also handle clicks on the label container (in case theme markup clicks don't toggle the radio)
  document.addEventListener('click', function (e) {
    var label = e.target.closest ? e.target.closest('.purchase-option') : null;
    if (!label) return;
    // if the click target is not the radio itself, toggle the radio
    var radio = label.querySelector('input[type="radio"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      selectOptionLabel(label);
      // fire a change event for other listeners
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Safety: if the block is already on the page at script run, ensure selected class matches checked radio
  function syncInitialSelection() {
    var form = document.querySelector('#custom-product-form');
    if (!form) return;
    var checked = form.querySelector('input[type="radio"]:checked');
    if (checked) {
      var label = findOptionLabel(checked);
      selectOptionLabel(label);
    } else {
      // fallback: mark first option as selected
      var first = form.querySelector('.purchase-option');
      if (first) first.classList.add('selected');
    }
  }

  // Try immediate sync and again after short delay (covers late injection)
  syncInitialSelection();
  setTimeout(syncInitialSelection, 600); // 600ms covers most lazy renders
  // As a final fallback, run once more after 2s
  setTimeout(syncInitialSelection, 2000);
})();
